import React from 'react';
import { Box, Icon, Text, Title } from '@nimbus-ds/components';
import { IdCardIcon, UserIcon } from '@nimbus-ds/icons';
import { CustomerInterface } from 'commons/types';
import { useTranslationWithPrefix } from 'commons/utils';
import { documentMask } from 'domains/Brazil/commons/utils/document';
import ClientSkeleton from './ClientSkeleton';

interface ClientProps {
  customer: CustomerInterface;
}

function Client({ customer }: ClientProps) {
  const { t } = useTranslationWithPrefix('chargebackUpload.client');

  return (
    <Box
      display="flex"
      flexDirection="column"
      gap="2"
      data-testid="chargeback-upload-client"
    >
      <Title as="h4">{t('title')}</Title>
      <Box display="flex" flexDirection="row" gap="2">
        <Icon source={<IdCardIcon />} color="neutral-textLow" />
        <Text fontWeight="medium" color="neutral-textLow">
          {t('document', { document: documentMask(customer.document) })}
        </Text>
      </Box>
      <Box display="flex" flexDirection="row" gap="2">
        <Icon source={<UserIcon />} color="neutral-textLow" />
        <Text fontWeight="medium" color="neutral-textLow">
          {customer.name}
        </Text>
      </Box>
    </Box>
  );
}

Client.Skeleton = ClientSkeleton;
export default Client;
